import React, { useState } from 'react'

import { EmployeePremiumTable } from './EmployeePremiumTable'
import {
  EmployeePremiumsWrapper,
  ClickableText,
  PlanDetailsWrapper
} from './styles'

export const YourPlanDetails: React.FC<{
  expanded?: boolean
  header?: boolean
}> = ({ expanded = false, header = true }) => {
  const [showTable, setShowTable] = useState(expanded)

  return (
    <PlanDetailsWrapper>
      {header && <span style={{ fontSize: 25 }}>Your Plan Details</span>}
      <EmployeePremiumsWrapper className="border">
        <ClickableText onClick={() => setShowTable(!showTable)}>
          <h5 className="text-primary">Premiums Per Employee</h5>
          <p className="fs-12 font-weight-bold text-primary">
            How much would they pay per plan?
          </p>
        </ClickableText>
        {showTable && <EmployeePremiumTable />}
      </EmployeePremiumsWrapper>
    </PlanDetailsWrapper>
  )
}
